import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurrencyFunctionalityService {

  constructor() { }

  public static convertCurrencyToNumber(amount: string): number {
    const value = amount ? Number(amount.toString().replace(/,/g, '')) : 0;
    return value;
  }

  public static convertNumberToCurrency(value: number): string {
    const amount = (value !== undefined && value !== null) ? String(value).replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
    return amount;
  }

  /**
   * This function take the number of decimals mentioned from the value without rounding off
   * @param inputNumber The input number to be truncated
   * @param numberOfDecimals The number of decimals to be maintained while truncating the number
   * @returns The truncated number
   */
  public static getNumberWithoutRoundOff(inputNumber: number, numberOfDecimals: number) {
    const regExp = new RegExp('^-?\\d+(?:\.\\d{0,' + (numberOfDecimals || -1) + '})?');
    return inputNumber.toString().match(regExp)[0];
  }

  public static number_format(amount: string, decimals: number): string {
    amount = amount.toString().replace(/,/g, '');
    // amount = CurrencyFunctionalityService.convertCurrencyToNumber(amount)+0.00;
    // amount = '£' + CurrencyFunctionalityService.number_format(amount,2);
    const reg = new RegExp('^-?\\d+(?:\.\\d{0,' + (decimals || -1) + '})?');
    let formattedCurrency = amount.match(reg)[0];
    formattedCurrency = parseFloat(formattedCurrency).toFixed(2);
    return formattedCurrency.replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
